import React, { useEffect, useState } from 'react';
import { BsFormControl, BsFormSelect } from '../../collection/bootstrap/BootstrapComponents';
import BsModalForm from '../../collection/bootstrap/BsModalForm';
import Loading from '../../collection/icons/Loading';
import { apiForm, apiGet } from '../../utils/api';

export default function Gasto(props) {
    const isNew = props.idGasto < 1;

    const updateData = async () => await apiGet("gastos/get/" + props.idGasto);

    const checkData = formData => {
        let errors = {};
        // Fecha
        const fecha = formData.get("fecha");
        if (!fecha) {
            errors["fecha"] = "Campo obligatorio";
        }
        // Cantidad
        const cantidad = formData.get("cantidad");
        if (!cantidad) {
            errors["cantidad"] = "Campo obligatorio";
        }
        // Cliente
        const cliente = formData.get("cliente");
        if (!cliente) {
            errors["cliente"] = "Campo obligatorio";
        }
        // Categoria
        const categoria = formData.get("categoria");
        if (!categoria) {
            errors["categoria"] = "Campo obligatorio";
        }
        // Justificante
        const justificante = formData.get("justificante");
        if (isNew && justificante.size == 0) {
            errors["justificante"] = "Campo obligatorio";
        }
        return errors;
    }

    const saveData = async data => {
        data.set("cantidad", data.get("cantidad").replace(".", ","));
        const action = isNew ? "new" : "edit";
        const result = await apiForm("gastos/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nuevo gasto" : "Editar gasto"}
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            <GastoForm />
        </BsModalForm>
    );
}

function GastoForm(props) {
    const data = props.data;
    const errors = props.errors;

    // lists
    const [listClientes, setListClientes] = useState();
    const [listCategorias, setListCategorias] = useState();

    // update lists
    const updateClientes = async () => {
        await setListClientes(await apiGet("clientes/list"));
    };
    const updateCategorias = async () => {
        await setListCategorias(await apiGet("gastos/listCategorias"));
    };

    // update triggers
    useEffect(() => {
        updateClientes();
        updateCategorias();
    }, []);

    return (listClientes && listCategorias) ? <>
        <BsFormControl
            /* Fecha */
            label="Fecha" name="fecha"
            value={data.fecha} error={errors.fecha}
            type="date" />
        <BsFormControl
            /* Cantidad */
            label="Cantidad" name="cantidad"
            value={data.cantidad} error={errors.cantidad}
            className="mt-3" type="number"
            min={0} step={0.01} />
        <BsFormSelect
            /* Cliente */
            label="Cliente" name="cliente"
            value={data.cliente} error={errors.cliente}
            options={listClientes}
            className="mt-3" />
        <BsFormSelect
            /* Categoría */
            label="Categoría" name="categoria"
            value={data.categoria} error={errors.categoria}
            options={listCategorias}
            className="mt-3" />
        <BsFormControl
            /* Justificante */
            label="Justificante" name="justificante"
            value="" error={errors.justificante}
            className="mt-3" type="file" />
    </> : <Loading />;
}
